var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"interval-selector"},_vm._l((_vm.intervals),function([name, _],index){return _c('div',{key:`interval_selector_${index}`,staticClass:"interval-selector__item",class:{
            'interval-selector__item--active': name === _vm.currentInterval.name,
        },domProps:{"textContent":_vm._s(name)},on:{"click":function($event){return _vm.changeIntervalIndex(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }